import React, { useContext, useEffect, useState } from "react";
import { MyContext } from "../../context/Context";
import { AuthContext } from "../../services/AuthProvider";

export default function OtpInput({ length = 6 }) {
  const { mobileNumber } = useContext(MyContext);
  const { setOtpCode, handleOtpGeneration } = useContext(AuthContext);
  const [currentFocus, setCurrentFocus] = useState(0);
  const [otp, setOtp] = useState(new Array(length).fill(""));
  const [seconds, setSeconds] = useState(30);

  const handleClick = async () => {
    await handleOtpGeneration();
    setSeconds(30);
  };

  const handleChange = (element, index) => {
    if (isNaN(element.value)) return;
    const newOtp = [...otp];
    newOtp[index] = element.value;
    setOtp(newOtp);
    setOtpCode(newOtp.join(""));

    if (element.value !== "" && index < length - 1) {
      setCurrentFocus(index + 1);
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace" && otp[index] === "") {
      if (index > 0) {
        setCurrentFocus(index - 1);
      }
    }
  };

  const handleFocus = (index) => {
    setCurrentFocus(index);
  };

  const handlePaste = (e) => {
    const pasteData = e.clipboardData.getData("text").split("");
    if (pasteData.length !== length) return;

    const newOtp = [...otp];
    pasteData.forEach((char, index) => {
      if (!isNaN(char)) {
        newOtp[index] = char;
      }
    });
    setOtp(newOtp);
    setCurrentFocus(length - 1);
  };

  useEffect(() => {
    if (seconds > 0) {
      const interval = setInterval(() => {
        setSeconds((prevSeconds) => prevSeconds - 1);
      }, 1000);

      return () => clearInterval(interval);
    }
  }, [seconds]);

  return (
    <section className="text-center mt-[36px]">
      <div>Enter OTP sent to {mobileNumber}</div>
      <div className="flex justify-center space-x-2">
        {otp.map((data, index) => (
          <input
            key={index}
            type="text"
            maxLength="1"
            value={data}
            onChange={(e) => handleChange(e.target, index)}
            onKeyDown={(e) => handleKeyDown(e, index)}
            onFocus={() => handleFocus(index)}
            onPaste={handlePaste}
            ref={(input) => input && index === currentFocus && input.focus()}
            className="w-10 h-10 text-center text-xl border-b-2 border-gray-300 focus:outline-none focus:border-b-2 focus:border-blue-500"
          />
        ))}
      </div>
      <div className="mt-[20px]">
        Didn’t receive the OTP?{" "}
        <button
          className={`${!!seconds ? "text-[#A3A3A3]" : "text-[#1C75BC]"}`}
          onClick={handleClick}
          disabled={!!seconds ? true : false}
        >
          RESEND OTP
        </button>{" "}
        <span className="text-[#1C75BC]">{!!seconds && `${seconds} SEC`}</span>
      </div>
    </section>
  );
}
